import React from 'react';
import { MapPinIcon, FileCheckIcon, AlertCircleIcon, ChevronRightIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { samplePlots } from '../data/sampleData';
export function MyPlotsPage({
  navigateTo,
  setSelectedPlotId
}: {
  navigateTo: (page: string) => void;
  setSelectedPlotId: (id: string) => void;
}) {
  const {
    language,
    t
  } = useLanguage();
  const handlePlotClick = (id: string) => {
    setSelectedPlotId(id);
    navigateTo('plotDetails');
  };
  return <div className="space-y-6" data-id="element-1098">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" data-id="element-1099">
        <div data-id="element-1100">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-1101">
            {t('navMyPlots')}
          </h1>
          <p className="text-sm text-gray-500 mt-1" data-id="element-1102">
            Manage all your linked land records
          </p>
        </div>
        <button onClick={() => navigateTo('createRecord')} className="px-4 py-2 bg-[#006A4E] text-white rounded-lg font-medium hover:bg-[#004D3A] transition-colors shadow-sm text-sm" data-id="element-1103">
          {t('createRecord')}
        </button>
      </div>

      <div className="grid grid-cols-1 gap-4" data-id="element-1104">
        {samplePlots.map(plot => <div key={plot.id} onClick={() => handlePlotClick(plot.id)} className="bg-white rounded-xl shadow-sm border border-gray-200 p-5 hover:border-[#006A4E] hover:shadow-md transition-all cursor-pointer group" data-id="element-1105">
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-1106">
              <div className="flex items-start space-x-4" data-id="element-1107">
                <div className="w-12 h-12 bg-green-50 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-[#006A4E] transition-colors" data-id="element-1108">
                  <MapPinIcon className="w-6 h-6 text-[#006A4E] group-hover:text-white" data-id="element-1109" />
                </div>
                <div data-id="element-1110">
                  <div className="flex items-center space-x-2" data-id="element-1111">
                    <h3 className="text-lg font-bold text-gray-900" data-id="element-1112">
                      {language === 'bn' ? plot.nameBn : plot.name}
                    </h3>
                    {plot.cloId && <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800" data-id="element-1113">
                        <FileCheckIcon className="w-3 h-3 mr-1" data-id="element-1114" /> CLO Active
                      </span>}
                  </div>
                  <p className="text-sm text-gray-500 mt-1" data-id="element-1115">
                    {plot.id} •{' '}
                    {language === 'bn' ? plot.districtBn : plot.district},{' '}
                    {language === 'bn' ? plot.upazilaBn : plot.upazila}
                  </p>
                  <div className="flex flex-wrap gap-2 mt-3" data-id="element-1116">
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-1117">
                      {t('khatian')}: {plot.khatian}
                    </span>
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-1118">
                      {t('dag')}: {plot.dag}
                    </span>
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-1119">
                      {plot.area} {t('area').split(' ')[0]}
                    </span>
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-between md:justify-end space-x-4 md:w-1/3 border-t md:border-t-0 pt-4 md:pt-0 mt-2 md:mt-0 border-gray-100" data-id="element-1120">
                <div className="flex flex-col space-y-2" data-id="element-1121">
                  <div className="flex items-center space-x-2" data-id="element-1122">
                    <span className="text-xs text-gray-500 w-16" data-id="element-1123">
                      {t('taxStatus')}:
                    </span>
                    <span className={`text-xs font-semibold ${plot.taxStatus === 'paid' ? 'text-green-600' : 'text-red-600'}`} data-id="element-1124">
                      {t(plot.taxStatus as any)}
                    </span>
                  </div>
                  <div className="flex items-center space-x-2" data-id="element-1125">
                    <span className="text-xs text-gray-500 w-16" data-id="element-1126">
                      {t('mutationStatus')}:
                    </span>
                    <span className={`text-xs font-semibold ${plot.mutationStatus === 'completed' ? 'text-green-600' : 'text-amber-600'}`} data-id="element-1127">
                      {t(plot.mutationStatus as any)}
                    </span>
                  </div>
                  {plot.dispute && <div className="flex items-center space-x-1 text-red-600" data-id="element-1128">
                      <AlertCircleIcon className="w-3 h-3" data-id="element-1129" />
                      <span className="text-xs font-semibold" data-id="element-1130">Disputed</span>
                    </div>}
                </div>
                <ChevronRightIcon className="w-5 h-5 text-gray-400 group-hover:text-[#006A4E]" data-id="element-1131" />
              </div>
            </div>
          </div>)}
      </div>
    </div>;
}